import { FSA } from "flux-standard-action/lib";

import { dispatcher } from "../../../dispatcher";
import { Store } from "../../../flux/Store";
import { names } from "./SelectedItemsActions";
import { names as listNames } from "./ListActions";
import { ListStore } from "./ListStore";
import { Key } from "../../../models";

export interface SelectedItemsStoreState
{
    selected: Set<Key>;
    allSelected: boolean;
    disabled: boolean;
}

// This Flux store is used to manage selected entities in tables
export class SelectedItemsStore<T> extends Store<SelectedItemsStoreState>
{
    lastChange: Date = null;

    constructor(listStore: ListStore<T>, token: any)
    {
        super();
        this.state = {
            selected: new Set(),
            allSelected: false,
            disabled: true,
        };

        this.register<Key>(names.TOGGLE_ITEM, e => {
            if(e.meta === token) {
                dispatcher.waitFor([ listStore.dispatchToken ]);

                const key = e.payload;
                const { items } = listStore.getState();
                const validKeys = new Set(items.map(listStore.key));

                if(!validKeys.has(key))
                    return;

                const selected = new Set(this.state.selected);
                if(selected.has(key)) {
                    selected.delete(key);
                } else {
                    selected.add(key);
                }

				this.lastChange = new Date();

                return { selected, allSelected: selected.size === validKeys.size && validKeys.size > 0, disabled: validKeys.size === 0};
            }
        });

        this.register(names.TOGGLE_ALL, e => {
            if(e.meta === token) {
                dispatcher.waitFor([ listStore.dispatchToken ]);

                const { allSelected, disabled } = this.state;
                if(!disabled) {
                    if(allSelected)
                        return this.field({ allSelected: false, selected: new Set() });

                    this.lastChange = new Date();

                    const { items } = listStore.getState();
                    return this.field({ allSelected: true, selected: new Set(items.map(listStore.key)) });
                }
            }
        });

        this.register(names.SELECT_ALL, e => {
            if(e.meta === token) {
                dispatcher.waitFor([ listStore.dispatchToken ]);

                const { allSelected, disabled } = this.state;
                if(!disabled) {

                    this.lastChange = new Date();

                    const { items } = listStore.getState();
                    localStorage.setItem('groupActionVehicleIds', JSON.stringify(items.map(listStore.key)));
                    return this.field({ allSelected: true, selected: new Set(items.map(listStore.key)) });
                }
            }
        });

        const tryReduceState = (e: FSA<any, any>, clear = false) => {
            if(e.meta === listStore.token) {
                dispatcher.waitFor([ listStore.dispatchToken ]);
                return reduceState(clear);
            }
        };

        const reduceState = (clear: boolean): SelectedItemsStoreState => {
            const { items } = listStore.getState();
            const validKeys = new Set(items.map(listStore.key));

            const { selected } = this.state;
            const intersection = clear ? new Set() : new Set([...validKeys].filter(k => selected.has(k)));

            return { selected: intersection, allSelected: intersection.size === validKeys.size && validKeys.size > 0, disabled: validKeys.size === 0 };
        }

        this.register(listNames.REPLACE_ITEMS, tryReduceState);
        this.register(listNames.SET_ITEMS, e => tryReduceState(e, true));
        this.register(listNames.UPSERT_ITEMS, tryReduceState);
        this.register(listNames.REMOVE_ITEMS, tryReduceState);
    }

    toArray()
    {
        return [...this.state.selected];
    }
}


// WEBPACK FOOTER //
// ./src/app/flux/Grid/SelectedItemsStore.ts